/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { WorkflowSettingsContainer as WorkflowSettings } from './WorkflowSettings.container';
